// src/services/fetchAuthPatch.js
// ------------------------------------------------------------------
// Sostituisce window.fetch con una versione che inserisce sempre
// l'header Authorization: Bearer <access_token> (se esiste).
// ------------------------------------------------------------------

export function patchFetchWithAuth() {
  const originalFetch = window.fetch;

  window.fetch = async (input, init = {}) => {
    const token = localStorage.getItem("access_token") || "";
    const mergedInit = { ...init };

    // Unisci / crea gli headers
    const hdrs = new Headers(init?.headers || {});
    if (token && !hdrs.has("Authorization")) {
      hdrs.set("Authorization", `Bearer ${token}`);
    }
    mergedInit.headers = hdrs;

    // Esegui la chiamata originale
    return originalFetch(input, mergedInit);
  };
}
